<template>
<custom-dialog :need-close="true" :btn-list="['更改类型 重新报名', '继续完善报名信息']" @close="close" @btn-click="choose">
<div class="login-dialog">
  <img src="../assets/icon-warning.png">
  <div v-if="type === 1" class="login-dialog-content">
    您有尚未提交的申请单，且为”<strong>{{companyName}}</strong>“合作招募，是否重新报名，并更改为个人加盟。
  </div>
  <div v-if="type === 2" class="login-dialog-content">
    您有尚未提交的申请单，且为个人加盟，是否重新报名，并更改为”{{companyName}}“合作招募。
  </div>
  <div v-if="type === 3" class="login-dialog-content">
    您有尚未提交的申请单，且为”<strong>{{companyName}}</strong>“合作招募，是否重新报名，并更改为”<strong>{{otherCompanyName}}</strong>“合作招募。
  </div>
</div>
</custom-dialog>
</template>

<script>
import CustomDialog from './custom-dialog'
export default {
  components: {
    CustomDialog
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
    companyName: {
      type: String,
      default: ''
    },
    otherCompanyName: {
      type: String,
      default: ''
    }
  },
  methods: {
    choose (index) {
      if (index === 0) {
        this.$emit('transform')
      } else {
        this.$emit('next')
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.login-dialog {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  img {
    margin: 60px 0;
    width: 80px;
    height: 80px;
  }

  .login-dialog-content {
    color: $ucar_font_color;
    padding: 0 30px;
    line-height: 2;
    font-size: $ucar_font_h4;
    margin-bottom: 20px;

    strong {
      font-weight: bolder;
    }
  }
}
</style>